module.exports = __webpack_public_path__ + "img/no-inspectionlists.33d9126c.svg";